module.exports = __webpack_public_path__ + "static/2019-publicArt-1-083f18c6f1705b98daee1a0ae6a37055.jpg";